import * as React from 'react';
import { clsx } from 'clsx';
import { useDeviceType } from '@cian/ui-kit';
import { getDeviceStyles } from '../../styles/tab/getDeviceStyles';

export interface ITabProps {
  title: number | string;
  count?: number | string;
  disabled?: boolean;
  active?: boolean;
  focusVisible: boolean;
  onClick(e: React.MouseEvent): void;
}

export const Tab = ({ title, disabled, active, focusVisible, onClick, count }: ITabProps) => {
  const deviceType = useDeviceType();
  const styles = getDeviceStyles(deviceType);

  return (
    <button
      disabled={disabled}
      type="button"
      role="tab"
      aria-selected={active}
      tabIndex={active ? 0 : -1}
      className={clsx(styles['tab'], active && styles['active'], focusVisible && styles['focus-visible'])}
      onClick={onClick}
    >
      <span className={styles['text']}>{title}</span>
      {count !== undefined && <mark className={styles['count']}>{count}</mark>}
    </button>
  );
};
